import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#F2EDE4] border-t border-[rgba(41,37,36,0.08)]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-medium text-[#292524] mb-4">
              Visible Foundation
            </h3>
            <p className="font-body text-sm text-[#57534E] leading-relaxed max-w-xs">
              Making the unseen seen through documentary filmmaking, storytelling, and intentional partnership.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-[#C86B53] font-medium mb-4">
              Navigate
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about-us", label: "About Us" },
                { to: "/films", label: "Films" },
                { to: "/donate", label: "Donate" },
                { to: "/contact-us", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="font-body text-sm text-[#57534E] hover:text-[#C86B53] transition-colors"
                  data-testid={`footer-${link.label.toLowerCase()}-link`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-[#C86B53] font-medium mb-4">
              Get in Touch
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:thevisible.foundation@gmail.com"
                className="flex items-center gap-2 font-body text-sm text-[#57534E] hover:text-[#C86B53] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={14} strokeWidth={1.5} />
                thevisible.foundation@gmail.com
              </a>
              <a
                href="tel:734-928-8369"
                className="flex items-center gap-2 font-body text-sm text-[#57534E] hover:text-[#C86B53] transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={14} strokeWidth={1.5} />
                734-928-8369
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[rgba(41,37,36,0.08)]">
          <p className="font-body text-xs text-[#57534E] text-center">
            &copy; {new Date().getFullYear()} Visible Foundation. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
